import { render } from "./TeamSelectionDropdown.vue?vue&type=template&id=703c8316&ts=true"
import script from "./TeamSelectionDropdown.vue?vue&type=script&lang=ts"
export * from "./TeamSelectionDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__